import { useMemo, useState } from "react";
import Button from "../../../../../../publicComponent/Button";
import AddCartButton from "../../../../../../reducer/moduleReducer/goodsDetail/components/AddCartButton";
import {
  GoodsDetailController,
  useGoodsDetailContext,
} from "../../../../../../reducer/moduleReducer/goodsDetail";
import SelectMall9 from "../../../../components/SelectMall9";
import { getI18n, useTranslation } from "react-i18next";
import Modal from "../../../../../../publicComponent/Modal";
import { useNavigateTo } from "../../../../../../hooks/useNavigateTo";
import CountControl from "../../../../components/CountControl";
import { isEmptyObj, calc } from "../../../../../../utils";
import ShareNav from "../../../../../../publicComponent/ShareNav";
import AddWishButton from "../../../../../../reducer/moduleReducer/goodsDetail/components/AddWishButton";
import Buffer from "../../../../../../publicComponent/Buffer";
import Pagination from "../../../../../../publicComponent/Pagination";

function Title({ label, active, handle }) {
  return (
    <p
      className={
        "cursor-pointer flex-1 text-[16px] text-center pb-[12px] border-b-[2px] " +
        (active ? "font-bold" : "")
      }
      onClick={handle}
    >
      {label}
    </p>
  );
}

export default function RightDetailBlock() {
  const [visible, setVisible] = useState(false);
  const {
    selectSpec,
    gotoConfirmOrder,
    countHandle,
    setDetailTabActive,
    getComment,
    setSkuItem
  } = GoodsDetailController();
  const { state } = useGoodsDetailContext();
  const {
    detail,
    count,
    spec,
    detailTabActive,
    commentTotal,
    commentList,
    commentQuery,
    skuItem
  } = state;
  const { t } = useTranslation();
  const lang = getI18n().language;
  const navigateTo = useNavigateTo();

  // 规格列表添加一个字段
  let specListRes = useMemo(() => {
    let res = detail.specListRes;
    if (detail.specListRes) {
      res = detail.specListRes.map((item) => {
        return {
          ...item,
          // selectSpecName: `${detail.specList[0].specName}: ${item.specName}`
        };
      });
    }
    return res;
  }, [detail]);

  const addCartAfter = () => {
    setVisible(true);
  };

  return (
    <>
      <div className="xl:px-[80px] px-[34px] flex-none w-[44%]">
        <h1 className="text-[22px] mb-[15px]">{lang === 'en'?detail.itemEnName:detail.itemName}</h1>
        {/*<p className="py-[22px] text-[16px] font-bold">${detail.priceArea}</p>*/}
        <p className="text-[14x] text-[#999] mb-[25px]">
          {detail.secondCategoryName}
        </p>
        <div className="relative">
          {/* <p className="absolute left-0 top-[20px] text-[15px] font-bold text-[#333] z-10">
            {detail?.specList[0]?.specName}
          </p> */}
          {/* <SelectMall9
            placeholder="请选择规格"
            options={specListRes}
            onChange={selectSpec}
            keyValue={{ label: "specName", value: "specSkuId" }}
          /> */}
          {detail?.specList.map((item, i) => (
            <div className="mb-[10px]" key={i}>
              <p className="text-[15px] inline-block mr-[10px]">
                {lang === "en" ? item.specNameEn : item.specName}:
              </p>
              {item.specNameValueList.map((_item, j) => (
                <a
                  key={j}
                  style={{ minWidth: 36 }}
                  onClick={() => setSkuItem(item, i, j)}
                  className={`inline-block text-center border border-[#ddd] p-[7px] px-[8px] rounded-full cursor-pointer ml-[8px] ${
                    _item === skuItem[i]?.specValue
                      ? "border-[#c7a17a] text-[#c7a17a]"
                      : ""
                  }`}
                >
                  {_item}
                </a>
              ))}
            </div>
          ))}
        </div>

        <div className="border-b border-[#d4d4d4] flex py-[18px] mb-[30px] flex justify-between pr-[12px]">
          <p className="left-0 top-[20px] text-[15px] font-bold text-[#333]">
            {t("数量")}
          </p>
          <CountControl
            count={count}
            addCount={countHandle}
            subCount={countHandle}
          />
        </div>
        <h1 className="mt-[25px] flex items-center text-[15px] mb-[8px]">
          <span>单价：</span>
          <span>${isEmptyObj(spec) ? detail.priceArea : spec.price}</span>
        </h1>

        {!isEmptyObj(spec) && (
          <h1 className="mb-[40px] flex items-center">
            <span>总价：</span>
            <span className="font-bold text-[24px]">
              ${calc.add(spec.price * count)}
            </span>
          </h1>
        )}

        <div className="flex mb-[16px] mt-[40px]">
          <AddCartButton
            submitAfter={addCartAfter}
            className="rounded-[12px] bg-[#ECBC40] flex-1 text-[14px] py-[12px] h-[46px] mr-[20px]"
          />

          <Button
            onClick={gotoConfirmOrder}
            className="rounded-[12px] bg-[#333] flex-1 text-[14px] text-white py-[12px] h-[46px]"
          >
            {t("现在购买")}
          </Button>
        </div>
        <div>
          <AddWishButton
            detail={detail}
            className="rounded-[12px] border-[1px] border-[#666] mb-[12px] w-[100%] py-[8px]"
          />
        </div>
        <ShareNav />

        <div className="py-[45px] text-left">
          <div className="flex">
            <Title
              active={detailTabActive === 0}
              handle={() => setDetailTabActive(0)}
              label={t("产品信息")}
            />
            <Title
              active={detailTabActive === 1}
              handle={() => setDetailTabActive(1)}
              label={`${t("评价")} (${commentTotal})`}
            />
          </div>
          {detailTabActive === 0 && (
            <div
              className="p-[10px]"
              dangerouslySetInnerHTML={{
                __html: lang === "en" ? detail.introEn : detail.intro,
              }}
            />
          )}

          {detailTabActive === 1 && commentList && (
            <div className="mdmax:hidden">
              {commentList.length > 0 ? (
                commentList.map((item, i) => (
                  <div
                    className="p-[20px] px-[12px] border-b-[1px] relative"
                    key={i}
                  >
                    <div className="mr-[40px] mt-[10px]">
                      <div className="inline-block rounded-full w-[42px] h-[42px] bg-[#aaa]">
                        {item.headImg && (
                          <img
                            src={item.headImg}
                            className="w-[100%] h-[100%]"
                          />
                        )}
                      </div>
                      <div
                        className="inline-block ml-[10px]"
                        style={{ verticalAlign: "top" }}
                      >
                        <p>{item.nickname || "--"}</p>
                        <p className="text-[#666] text-[12px]">
                          {item.updateTime}
                        </p>
                      </div>
                    </div>
                    <div className="flex-1"></div>
                    <p className="text-[#666] pl-[8px]">
                      {item.comment || "无评价"}
                    </p>
                    <p className="absolute right-0 top-[24px]">
                      {Array.from({ length: item.starNum })
                        .map((item) => 1)
                        .map((star, index) => (
                          <i
                            className="iconfont icon-star-fill text-[18px] text-[#FFC75A]"
                            key={index}
                          />
                        ))}
                    </p>
                  </div>
                ))
              ) : (
                <Buffer.Empty content={t("暂无评价信息")} />
              )}
              {Number(commentTotal) > 0 && (
                <Pagination
                  total={commentTotal}
                  current={commentQuery?.page}
                  pageSize={commentQuery?.limit}
                  className="mt-[30px]"
                  onChange={(page) => getComment({ page })}
                />
              )}
            </div>
          )}
        </div>
      </div>
      <Modal visible={visible} width={270} onClose={setVisible} footer={null}>
        <div className="text-center">
          <h1 className="text-[20px] mb-[25px]">{t("已添加到购物车")}</h1>
          <Button
            onClick={() => navigateTo("/goodsList")}
            className="rounded-none py-[12px] bg-[#333] w-[100%] mb-[20px] text-white"
          >
            {t("继续选购")}
          </Button>
          <Button
            onClick={gotoConfirmOrder}
            className="py-[12px] border border-[#333] w-[100%] mb-[30px]"
          >
            {t("前往结算")}
          </Button>
        </div>
      </Modal>
    </>
  );
}
